export const GENDER_OPTIONS = [
  'Male', 'Female', 'Non-binary', 'Transgender male', 'Transgender female',
  'Genderqueer/Genderfluid', 'Prefer not to say', 'Other'
];

export const ETHNICITY_OPTIONS = [
  'White/Caucasian', 'Black/African American', 'Hispanic/Latino', 'Asian',
  'Native American/Alaska Native', 'Native Hawaiian/Pacific Islander',
  'Middle Eastern/North African', 'Multiracial', 'Prefer not to say', 'Other'
];

export const COUNTRIES = [
  'United States', 'Canada', 'United Kingdom', 'Australia', 'Germany',
  'France', 'India', 'Mexico', 'Brazil', 'Other'
];

export const US_STATES = [
  'Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado',
  'Connecticut', 'Delaware', 'District of Columbia', 'Florida', 'Georgia',
  'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky',
  'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota',
  'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire',
  'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota',
  'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island',
  'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont',
  'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'
];

export const CA_PROVINCES = [
  'Alberta', 'British Columbia', 'Manitoba', 'New Brunswick',
  'Newfoundland and Labrador', 'Nova Scotia', 'Ontario',
  'Prince Edward Island', 'Quebec', 'Saskatchewan',
  'Northwest Territories', 'Nunavut', 'Yukon'
];

export const EDUCATION_OPTIONS = [
  'Less than high school', 'High school diploma/GED', 'Some college',
  'Associate degree', "Bachelor's degree (e.g. BA, BS)",
  "Master's degree (e.g. MA, MS, MBA)", 'Doctorate (e.g. PhD, MD, JD)',
  'Prefer not to say'
];

export const INCOME_OPTIONS = [
  '$0 - $24,999', '$25,000 - $49,999', '$50,000 - $74,999',
  '$75,000 - $99,999', '$100,000 - $149,999', '$150,000+',
  'Prefer not to say'
];

export const LANGUAGE_OPTIONS = [
  'I am fluent in only English',
  'I am fluent in English and other languages',
  'I am not fluent in English'
];

export const CONTACT_PREFERENCES = ['Email', 'Phone', 'Text message'];

export const INSURANCE_OPTIONS = [
  'Employer-sponsored', 'Marketplace/ACA', 'Medicare', 'Medicaid',
  'Military/VA', 'Self-pay/Uninsured', 'Other'
];

export const CONDITION_SUGGESTIONS = [
  'Lupus', 'Narcolepsy', 'Polycythemia Vera', 'Diabetes Type 1',
  'Diabetes Type 2', 'Multiple Sclerosis', 'Rheumatoid Arthritis',
  "Crohn's Disease", 'Ulcerative Colitis', 'Fibromyalgia', 'Psoriasis',
  'Breast Cancer', 'Lung Cancer', 'Prostate Cancer', 'Asthma', 'COPD',
  'Heart Failure', 'Hypertension', 'Depression', 'Anxiety', 'ADHD',
  'Epilepsy', 'Migraine', 'Endometriosis', 'PCOS', 'Sickle Cell Disease'
];

export const MEDICATION_SUGGESTIONS = [
  'Metformin', 'Lisinopril', 'Atorvastatin', 'Levothyroxine', 'Amlodipine',
  'Metoprolol', 'Omeprazole', 'Losartan', 'Gabapentin', 'Hydrochlorothiazide',
  'Sertraline', 'Prednisone', 'Hydroxychloroquine', 'Benlysta', 'Saphnelo',
  'Humira', 'Enbrel', 'Rituxan', 'Xyrem', 'Wakix', 'Sunosi'
];
